import React from "react";
import { FormGroup, Label, Input } from "reactstrap";
import { Controller } from "react-hook-form";

export const Checkbox = ({
  name,
  label,
  disabled,
  control,
  required,
  className = "",
}) => (
  <Controller
    rules={{ required }}
    name={name}
    control={control}
    render={({ field: { onChange, value } }) => (
      <FormGroup check inline className={`${className}`}>
        <Label disabled={disabled} check>
          {label}
        </Label>
        <Input
          type="checkbox"
          disabled={disabled}
          onChange={onChange}
          checked={value}
        />
      </FormGroup>
    )}
  />
);
